export default __webpack_public_path__ + "static/media/pool.da9585eb.jpeg";